import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { ClienteTypeaheadSharedModule } from '../../../../../pessoa/cliente/typeahead';

import { CampanhaClienteFormComponent } from './campanha-cliente-form.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteTypeaheadSharedModule
    ],
    declarations: [
        CampanhaClienteFormComponent
    ],
    exports: [
        CampanhaClienteFormComponent
    ]
})
export class CampanhaClienteFormModule { }
